import { z } from "zod";
import { fatorDeCorrecaoSchema, quantidadeSchema } from "./material";

/**
 * Equipamento — a máquina do laboratório e o consumível que ela come.
 *
 * O gasto é cadastrado por material porque é aí que ele varia: fresar dissilicato desgasta a broca
 * num ritmo diferente de fresar resina. `materialOptionId` nulo é a linha de escape, o gasto de
 * quem não foi nomeado.
 */

export const equipamentoIdSchema = z.object({ equipmentId: z.string().min(1) });

export const equipamentoSalvarSchema = z.object({
  /** Ausente = equipamento novo. */
  id: z.string().min(1).optional(),
  name: z.string().trim().min(2, "Dê um nome ao equipamento").max(120),
  notes: z.string().trim().max(2000).nullish(),
  /** Com que materiais do cardápio a máquina trabalha. Substitui a lista inteira. */
  materialOptionIds: z.array(z.string().min(1)).max(50).default([]),
});
export type EquipamentoSalvarInput = z.infer<typeof equipamentoSalvarSchema>;

export const equipamentoAtivoSchema = equipamentoIdSchema.extend({ ativo: z.boolean() });

export const equipamentoGastoLinhaSchema = z.object({
  materialLineId: z.string().min(1),
  quantityNet: quantidadeSchema,
  correctionFactor: fatorDeCorrecaoSchema.default(1),
});

/** Substitui o gasto de um par (equipamento, material) inteiro — a mesma forma de salvar da
 *  ficha técnica, que evita reconciliar linha a linha. */
export const equipamentoGastoSalvarSchema = equipamentoIdSchema.extend({
  /** Null = o gasto padrão, que vale pra qualquer material. */
  materialOptionId: z.string().min(1).nullish(),
  lines: z.array(equipamentoGastoLinhaSchema).max(60),
});
export type EquipamentoGastoSalvarInput = z.infer<typeof equipamentoGastoSalvarSchema>;
